import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NextHead from 'next/head';
import { toast } from 'react-toastify';
import { withTranslation } from 'utils/with-i18next';

import ChannelWrapper from 'components/Channel/ChannelWrapper';
import EmptyChannel from 'components/Channel/EmptyChannel';
import CreateChannel from 'components/Channel/CreateChannel';
import Loading from 'components/Common/Loading';
import Layout from 'components/Layout';
import PageComponent from 'pages/PageComponent';
import UserActions from 'redux/UserActions';
import ChannelClass from 'classes/ChannelClass';
import BASIC_CONSTANT from 'constants/basic.constants.js/basic.constants.js';

const subs = {
  invited: 'invitedSub',
  created: 'createdSub',
  nojoined: 'NojoinedSub',
};

// 메타 정보 상수
const META = {
  title: 'BGMs - My Channel',
  description: 'BGMs (brumz) - Share YouTube playlists and fill your space with music.',
  url: 'https://bgms.live/myChannel',
  image: 'https://bgms-bucket.s3.ap-northeast-2.amazonaws.com/channel/image/bgmsMetaImg.jpg',
};

class MyChannelView extends PageComponent {
  constructor(props) {
    super(props);
    this.state = {
      popUp: false,
      invitedList: [],
      createdList: [],
      joinedList: [],
      subs,
      loading: true,
    };
    this.channel = new ChannelClass();
  }

  componentDidUpdate() {}

  componentDidMount() {
    super.componentDidMount();
    let token = localStorage.getItem(BASIC_CONSTANT.USER_TOKEN_KEY);
    this.getData(token);
  }

  async getData(token) {
    let { createdList, joinedList } = this.state;
    const myChannel = await this.channel.getMyChannel(token);
    const invitedList = await this.channel.getInviteChannels(token);
    const userEmail = this.props.UserRedux.user && this.props.UserRedux.user.email;

    if (myChannel) {
      myChannel.map(v => {
        if (v.ownerEmail === userEmail) {
          createdList.push(v);
        } else if (v.ownerEmail !== userEmail) {
          joinedList.push(v);
        }
      });
    }

    this.setState({ createdList, joinedList, invitedList: invitedList, loading: false });
  }

  inviteData(target, t) {
    let { joinedList, invitedList } = this.state;
    if (target.type === 'invite') {
      const list = invitedList.filter(v => v.id === target.id);
      joinedList.unshift(list[0]);
      toast(`[${list[0].channelName}] ${t('inviteConfirm')}`, {
        position: 'bottom-center',
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
    }

    invitedList = invitedList.filter(v => v.id !== target.id);
    this.setState({ joinedList, invitedList });
  }

  setCreatedList(state) {
    let { createdList } = this.state;
    createdList.unshift(state);
    this.setState({ createdList });
  }

  renderHead() {
    return (
      <NextHead>
        <title>{META.title}</title>
        <meta name="description" content={META.description} />
        <meta name="subject" content={META.description} />
        {/* Open Graph */}
        <meta property="og:title" content={META.title} />
        <meta property="og:description" content={META.description} />
        <meta property="og:url" content={META.url} />
        {/* Twitter */}
        <meta name="twitter:title" content={META.title} />
        <meta name="twitter:description" content={META.description} />
        <meta name="twitter:image" content={META.image} />
        <meta name="twitter:domain" content={META.url} />
      </NextHead>
    );
  }

  handleMobileLogin = () => {
    const token = localStorage.getItem(BASIC_CONSTANT.USER_TOKEN_KEY);
    if (token) {
      window.location.href = `bgms://login?token=${token}`;
    }
  };

  renderContent() {
    const { createdList, joinedList, invitedList, popUp, subs: subsState } = this.state;
    const { t } = this.props;
    const totalChannels = (createdList?.length || 0) + (joinedList?.length || 0) + (invitedList?.length || 0);

    return (
      <section className="px-6 md:px-12 py-8 md:py-12">
        <div className="max-w-6xl mx-auto">
          {/* 모바일 플레이어 로그인 버튼 */}
          <div className="mb-6">
            <button
              onClick={this.handleMobileLogin}
              className="w-full bg-primary text-black font-semibold py-3 px-6 rounded-lg hover:bg-primary/90 transition-colors"
            >
              📱 모바일 플레이어로 로그인
            </button>
          </div>
          {totalChannels === 0 ? (
            <>
              <EmptyChannel
                setStatePopUp={state => {
                  this.setState({ popUp: state });
                }}
              />
              {popUp && (
                <CreateChannel
                  statePopUp={popUp}
                  setStatePopUp={state => {
                    this.setState({ popUp: state });
                  }}
                  setCreatedList={state => this.setCreatedList(state)}
                />
              )}
            </>
          ) : (
            <div className="space-y-8">
              {invitedList && invitedList.length !== 0 && (
                <ChannelWrapper
                  list={invitedList}
                  title={t('invitedChannel')}
                  sub={t(subsState.invited)}
                  type={'invited'}
                  setId={target => this.inviteData(target, t)}
                />
              )}

              <ChannelWrapper
                list={createdList}
                title={t('createdChannel')}
                sub={t(subsState.created)}
                type={'created'}
                popUp={() => this.setState({ popUp: true })}
              />

              <ChannelWrapper
                list={joinedList}
                title={t('joinedChannel')}
                type={'joined'}
                sub={joinedList.length === 0 && t(subsState.nojoined)}
              />

              {popUp && (
                <CreateChannel
                  statePopUp={popUp}
                  setStatePopUp={state => {
                    this.setState({ popUp: state });
                  }}
                  setCreatedList={state => this.setCreatedList(state)}
                />
              )}
            </div>
          )}
        </div>
      </section>
    );
  }

  render() {
    const { loading } = this.state;

    return (
      <>
        {this.renderHead()}
        {loading ? (
          <Loading />
        ) : (
          <Layout>
            {this.renderContent()}
          </Layout>
        )}
      </>
    );
  }
}

MyChannelView.propTypes = {
  UserRedux: PropTypes.object,
  t: PropTypes.func,
};

export default connect(
  state => state,
  (dispatch, ownProps) => ({
    ...UserActions(dispatch, ownProps),
  })
)(withTranslation('myChannel')(MyChannelView));
